export default __webpack_public_path__ + "static/media/2284.02d62db5.png";